import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { multiEmployeeSelectorV2FormField } from 'modules/employees/components/EmployeeSelectorV2/formField'

export function buildEmployeesSchema() {
  return z.object({
    employeesSelection: multiEmployeeSelectorV2FormField({
      label: i18n.t('trainings.training_requests.create.employee_selector_step'),
      mandatory: false,
      section: '',
      fieldConfig: {
        forcedFilters: { verb: 'TrainingsTrainingRequestRead' },
      },
    }),
  })
}

export const employeesSection = () => ({
  title: i18n.t('trainings.training_requests.create.employee_selector_step'),
})
